var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconX = function SvgIconX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.801 10h3.066l-6.731 8.487L30 30h-6.171l-4.832-6.996L13.466 30H10.4l7.13-9.078L10 10h6.325l4.365 6.391L25.8 10Zm-1.073 18.007h1.7L15.43 11.92h-1.825l11.122 16.088Z",
    fill: "currentColor"
  })));
};
export default SvgIconX;